
import type { CompanyDetails, CompanyDetailsRedirect } from '~/types/company'

export default defineNuxtRouteMiddleware(async (to) => {
  if (!to.name?.toString().startsWith('companies-id-slug')) return

  const { public: { wadApiBaseUrl } } = useRuntimeConfig()
  const localePath = useLocalePath()
  const { getToken } = useAuthUser()

  const companyId = to.params.id
  const companySlug = to.params.slug

  const apiUrl = `/v2/companies/details?company_id=${companyId}&company_slug=${companySlug}`

  let redirectUrl: string | null = null
  let errorStatus = 500

  const token = await getToken()
  const headers = token ? { Authorization: `Bearer ${token}` } : {}

  const companyResponse = await useFetch<CompanyDetails | CompanyDetailsRedirect>(apiUrl, {
    baseURL: wadApiBaseUrl,
    credentials: 'omit',
    redirect: 'manual',
    headers,
    onResponse({ response }) {
      if (response.status === 301 && response._data) {
        const data = response._data as CompanyDetailsRedirect

        redirectUrl = localePath({
          name: 'companies-id-slug',
          params: {
            id: data.company_id,
            slug: data.company_slug
          }
        })
      }
    },
    onResponseError({ response }) {
      errorStatus = response.status as number
    }
  })

  const { data: responseData, error: responseError } = companyResponse

  if (responseError.value) {
    throw showError({ statusCode: errorStatus ?? 500, fatal: true })
  }

  if (redirectUrl) {
    return navigateTo(redirectUrl, { redirectCode: 301 })
  }

  const companyDetails = useState<CompanyDetails | null>('companyDetails', () => null)
  companyDetails.value = responseData.value?.data as CompanyDetails
})
